import { isMobile } from "@/utils/action";

class AnalyticsTracker {
  trackPageView(page) {
    throw new Error("trackPageView method should be implemented");
  }

  trackEvent(category, action, label, value) {
    throw new Error("trackEvent method should be implemented");
  }
}

// 获取当前国家代码
const getCurrentCountry = () => {
  try {
    // 从localStorage获取i18nextLng中的国家代码
    const i18nextLng = localStorage.getItem("i18nextLng");
    if (i18nextLng) {
      return i18nextLng;
    }

    // 如果没有i18nextLng，则使用浏览器默认语言
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang) {
      // 提取语言代码的前两个字符（如 'en-US' -> 'en'）
      const langCode = browserLang.split('-')[0];
      return langCode;
    }

    // 默认返回英文
    return 'en';
  } catch (error) {
    console.error('获取国家代码失败:', error);
    return 'en';
  }
};

class GATracker extends AnalyticsTracker {
  trackPageView(page) {
    if (window.gtag) {
      window.gtag('config', 'G-RGC7VTRCE4', {
        page_path: page,
      });
    }
  }

  trackEvent(action, disableTracking = false) {
    if (typeof window !== 'undefined' && window.gtag) {
      const lastTag = isMobile() ? "h5" : "web";
      const currentCountry = getCurrentCountry();
      const realActionName = `${action}_v2_${lastTag}_${currentCountry}`;
      window.gtag('event', realActionName, {
        event_category: realActionName,
        event_label: realActionName,
        value: realActionName,
      });
      if (!disableTracking) {
        const allAction = `${action}_v2_all_${currentCountry}`;
        window.gtag('event', allAction, {
          event_category: allAction,
          event_label: allAction,
          value: allAction,
        });
      }

    }
  }
}

const gaTracker = new GATracker();
export default gaTracker;
